import React from "react";
import ReactDOM from "react-dom";
import Swal from 'sweetalert2';
import CookieConsent from "@root/CookieConsent";

window.Swal = Swal;

const container = document.getElementById("CookieConsent");
if (container) {
  ReactDOM.render(<CookieConsent />, container); // For React 17 or below
}

renderComponent(CookieConsent, "CookieConsent");
